/**
 * FIX-CLAUDE-B (D-314 §3) — the Google return of "connect Claude to OTE"
 * (OAuth for /mcp): the server signs its Google state with an "mcp." prefix.
 * The website's /login page forwards such a return to the server instead of
 * treating it as a website sign-in.
 */
export function isClaudeConnectReturn(state: string | null): boolean {
  return typeof state === 'string' && state.startsWith('mcp.');
}

/** The MCP address of this site (what Claude Code / the claude.ai Connector connect to). */
export function mcpUrl(origin: string = window.location.origin): string {
  return `${origin.replace(/\/+$/, '')}/mcp`;
}

/** `claude mcp add` with OAuth (sign in afterwards with /mcp). */
export function claudeCodeOAuthCommand(url: string): string {
  return `claude mcp add --transport http ote ${url}`;
}

/** `claude mcp add` with the personal key (the backup). */
export function claudeCodeKeyCommand(url: string, key: string): string {
  return `claude mcp add --transport http ote ${url} --header "Authorization: Bearer ${key}"`;
}

/** FIX-CLAUDE-B (D-314 §11) — the ids to ask about for the "Claude" tag: unique, lower-case, sorted, the last 500. */
export function claudeMarkIds(ids: ReadonlyArray<string | null | undefined>): string[] {
  const clean = [...new Set(ids.filter((x): x is string => typeof x === 'string' && x.length > 0).map((x) => x.toLowerCase()))];
  return clean.slice(-500).sort();
}

export function isClaudeMarked(marks: ReadonlySet<string>, id: string | null | undefined): boolean {
  return !!id && marks.has(id.toLowerCase());
}
